import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import AuthLayout from "../../../components/layout/AuthLayout"
import FormInput from "../../../components/layout/FormInput"
import Button from "../../../components/ui/Button"
import emailService from "../../../network/services/email.service"
import InvitationController from "@/network/controllers/invitation.controller"
import State, { STATE, CurrentEntityState, CurrentStudyState } from "@state";
import { useSession,clearSession } from "@/hooks/useSession";
import NavigationService from "@services/navigation.service.js";
import AuthController from "@controllers/auth.controller.js"; 

export default function CROSignUpEmail() {
  const [email, setEmail] = useState("christophe.baizone+1@gmail.com")
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null) 

  useEffect(() => {
    clearSession();
    State.reset();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError(null)

    if (!email.trim()) {
      setError("Please enter a valid email.")
      alert("Please enter a valid email.")
      setIsLoading(false)
      return
    }

    try {
      const response = await InvitationController.sendPublicInvitation({
        email: email.trim(),
        invitation_type: "cro", 
      })
      console.log("response from sendPublicInvitation:", response)

      if (response.success) {
        setIsSubmitted(true)
        alert("Email sent successfully!")
      } else {
        const errorMessage = response.message || "Failed to send invitation."
        setError(errorMessage)
        alert(errorMessage)
      }
    } catch (err) {
      console.error("Error sending email:", err)
      const errorMessage = "An unexpected error occurred. Please try again."
      setError(errorMessage)
      alert(errorMessage)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AuthLayout
      title="Create account"
      subtitle=""
      logoSrc="/img/logo.png"
      imageSrc="/img/Oshimed sign in image - earth.png"
      formWidth="third"
      logoPosition="top"
    >
      <div className="h-8"></div>
      {!isSubmitted ? (
        <form className="space-y-4" onSubmit={handleSubmit}>
          <FormInput
            label="Email address"
            id="email"
            name="email"
            type="email"
            placeholder="name@email.com"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button type="submit" variant="login" className="w-full font-bold" disabled={isLoading}>
            {isLoading ? "Sending..." : "Confirm Email"}
          </Button>
 
          {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
        </form>
      ) : (
        <div className="space-y-4">
          <div>
            <label htmlFor="email-disabled" className="block text-sm font-medium text-gray-700">
              Email address
            </label>
            <input
              id="email-disabled"
              type="email"
              value={email}
              className="w-full h-[60px] px-3 py-2 border border-gray-300 rounded-md bg-gray-200"
              disabled
            />
          </div>
          <div className="text-center font-medium text-gray-800 mt-4">
            <p>A verification email has been sent.</p>
            <p>Check your mailbox to continue.</p>
          </div>
          <div className="h-10"></div>
        </div>
      )}
      <div className="h-16"></div>
      
      <div className="h-1"></div>
      <div className="mb-4 text-center">
        <p> By creating an account, you agree to Oshimed's</p>
        <Link to="/condition-use" className="text-linkColor font-semibold hover:underline">
          Conditions of use
        </Link>
      </div>
      <div className="mt-4 text-center">
        <p className="text-gray-600 font-bold">
          You already have an account?{" "}
          <Link to="/" className="text-linkColor font-semibold hover:underline">
            Sign in
          </Link>
        </p>
      </div>
    </AuthLayout>
  )
}
